module.exports = __webpack_public_path__ + "assets/img/starter_main_frame.64c4a5d8.jpg";